<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="epigraph" role="doc-chapter">
<div class="senseline">
<p class="slh"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>A Noiseless patient spider</p>
<p class="sl">A noiseless, patient spider,</p>
<p class="sl">I mark’d, where, on a little promontory, it stood, isolated;</p>
<p class="sl">Mark’d how, to explore the vacant, vast surrounding,</p>
<p class="sl">It lauch’d forth filament, filament, filament, out of itself;</p>
<p class="sl">Ever unreeling them—ever tirelessly speeding them.</p>
<p class="slf">And you, O my Soul, where you stand,</p>
<p class="sl">Surrounded, surrounded, in measureless oceans of space,</p>
<p class="sl">Ceaselessly musing, venturing, throwing,—seeking spheres, to connect them;</p>
<p class="sl">Till the bridge you will need, be form’d—till the ductile anchor hold;</p>
<p class="sl">Till the gossamer thread you fling, catch somewhere, O my Soul.</p>
<p class="slt">—Walt Whitman</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-eberhard-0007.vue?ba0fb2cc